// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__20sZ1","content":"Consent_content__2aMpS","footer":"Consent_footer__1DRZ7"};